import React, { Component, useState, useRef, useEffect } from "react";
import parse from "html-react-parser";
// import Modal, { useModalState } from "react-simple-modal-provider";
import { IoMdClose, IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { MdUnfoldMore } from "react-icons/md";
import "./style.scss";
import { Label, Preloader, Text, Duration } from "pctComponents/atoms";
import {
  convertToBrDate,
  convertToBrDateWithHour,
  convertToBrDateWithHourStartAndHourFinish,
  getProfileInfo,
  sanitizeText,
  removeTagsHtml,
} from "services/utils";
import { userEnrollments, userEnrollmentRequest, getTeamsRegistration, getNodeBreadcrumb } from '../../../services/api';
import { Link, useLocation, BrowserRouter as Router } from "react-router-dom";
import { useHistory } from "react-router-dom";
import ModalLoadingInfo from "../../modals/ModalLoadingInfo";
import ModalDialog from "../../modals/ModalDialog";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { LuMapPin } from "react-icons/lu";
import { HiOutlineStatusOnline } from "react-icons/hi";
import { FaArrowRightLong, FaArrowDownLong } from "react-icons/fa6";
import { RiMapPin2Fill } from "react-icons/ri";
import { useCopyToClipboard } from "pctHooks/useCopyToClipboard";
import Popup from "reactjs-popup";
import { updateHasEnrollmentCampaign } from "actions";
import { connect } from "react-redux";
import { TreeItem, TreeView } from "@material-ui/lab";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import CloseIcon from "@material-ui/icons/Close";

type Props = {
  obj: any;
  updateHasEnrollmentCampaign: any
};

const compareNodeCode = (codeA = "", codeB = "") => {
  const partsA = codeA.split(".").map(Number);
  const partsB = codeB.split(".").map(Number);
  const len = Math.max(partsA.length, partsB.length);

  for (let i = 0; i < len; i++) {
    const a = partsA[i] ?? -1;
    const b = partsB[i] ?? -1;
    if (a !== b) return a - b;
  }

  return 0;
};

const buildOriginTree = (nodes: any[] = []) => {
  const byCode = new Map(nodes.map((node: any) => [node.nodeCode, { ...node, children: [] }]));
  const roots: any[] = [];

  for (const node of byCode.values()) {
    if (!node.nodeCode?.includes(".")) {
      roots.push(node);
      continue;
    }

    const parentCode = node.nodeCode.slice(0, node.nodeCode.lastIndexOf("."));
    const parent = byCode.get(parentCode);

    if (parent) parent.children.push(node);
    else roots.push(node);
  }

  const sortTree = (list: any[]) => {
    list.sort((a, b) => compareNodeCode(a.nodeCode, b.nodeCode));
    list.forEach((node) => node.children.length && sortTree(node.children));
  };

  sortTree(roots);
  return roots;
};

const ModalRegistration = NiceModal.create(({ obj, updateHasEnrollmentCampaign }: Props) => {
  const idSearch: any = obj.nodeCode;
  const history = useHistory();
  const fetchData = useRef<any>();
  const [openInstructorsByTeam, setOpenInstructorsByTeam] = useState({});

  const hasInstructors = (team: any) => Array.isArray(team?.instructors) && team.instructors.length > 0;

  const toggleInstructors = (idTeam: number) => {
    setOpenInstructorsByTeam((prev) => ({ ...prev, [idTeam]: !prev[idTeam] }));
  };

  const isInstructorsOpen = (idTeam: number) => !!openInstructorsByTeam[idTeam];

  const renderInstructorsCell = (team: any) => {
    if (!hasInstructors(team)) return <span>-</span>;

    const total = team.totalInstructors ?? team.instructors.length;
    const opened = isInstructorsOpen(team.idTeam);

    return (
      <button
        type="button"
        className="instructorsToggle"
        onClick={(e) => {
          e.stopPropagation();
          toggleInstructors(team.idTeam);
        }}
      >
        <span className="instructorsToggleText">{total} visualizar</span>
          {opened ? <IoIosArrowUp /> : <IoIosArrowDown />}
      </button>
    );
  };


  const [copyTextToClipboard] = useCopyToClipboard();
  const [showConfirmAwaitingApproval, setShowConfirmAwaitingApproval] =
    useState(false);
  const currentAwaitingApprovalTitle = useRef("Nome da turma");

  const [syllabusStatus, setSyllabusStatus] = useState(false);
  const [originModalOpen, setOriginModalOpen] = useState(false);
  const [originModalLoading, setOriginModalLoading] = useState(false);
  const [originModalError, setOriginModalError] = useState(false);
  const [originModalPath, setOriginModalPath] = useState<any[]>([]);
  const [originExpandedNodes, setOriginExpandedNodes] = useState<string[]>([]);
  const collection = obj;
  const enrollmentTargets = Array.isArray(collection.enrollmentTargets)
    ? collection.enrollmentTargets.filter(
        (target) => Boolean(target?.selfEnrollment) || Boolean(target?.hasTeamAvailable)
      )
    : [];
  let collectionToGo;

  if (collection.hasOwnProperty("collectionToGo")) {
    collectionToGo = collection.collectionToGo.data;
  }

  const columns = [
    {
      header: "Turma",
      accessor: "name",
    },
    {
      header: "Período para realização",
      accessor: "duration",
    },
    {
      header: "Data de início",
      accessor: "initialDate",
    },
    {
      header: "Data de término",
      accessor: "finalDate",
    },
    {
      header: "Capacidade",
      accessor: "capacity",
    },
    {
      header: "Vagas restantes",
      accessor: "totalVacanciesAvailable",
    },
    {
      header: "Instrutores",
      accessor: "totalInstructors",
    },
  ];

  const columnsMeet = [
    {
      header: "Turma",
      accessor: "name",
    },
    {
      header: "Período para realização",
      accessor: "period",
    },
    {
      header: "Tipo de encontro",
      accessor: "meetType",
    },
    {
      header: "Encontros",
      accessor: "meets",
    },
    {
      header: "Endereço",
      accessor: "adress",
    },
    {
      header: "Capacidade",
      accessor: "capacity",
    },
    {
      header: "Vagas restantes",
      accessor: "totalVacanciesAvailable",
    },    {
      header: "Instrutores",
      accessor: "totalInstructors",
    },
  ];

  const renderAccessor = (accessor, _data) => {
    const _meetingsInfo: any = meetingsInfo();

    switch (accessor) {
      case "period":
        return `${convertToBrDate(_data["initialDate"])} à ${convertToBrDate(
          _data["finalDate"]
        )}`;
        break;

      case "meetType":
        return _meetingsInfo.meetType;
        break;

      case "meets":
        return _meetingsInfo.meets;
        break;

      case "adress":
        return _meetingsInfo.adress;
        break;

      default:
        return _data[accessor];
        break;
    }
  };

  const renderRows = (dataRow: any, _key) => {
    let _row =
      dataRow.meetings.length == 0
        ? columns.map((colum: any, k) => {
            return (
  <td key={k}>
    <div>
      {colum.accessor === "totalInstructors" ? (
        renderInstructorsCell(dataRow)
      ) : colum.accessor == "initialDate" || colum.accessor == "finalDate" ? (
        convertToBrDate(dataRow[colum.accessor])
      ) : dataRow[colum.accessor] ? (
        colum.accessor == "duration" ? (
          dataRow[colum.accessor] + " dias"
        ) : (
          dataRow[colum.accessor]
        )
      ) : colum.accessor === "totalVacanciesAvailable" &&
        dataRow[colum.accessor] === null ? (
        "ilimitadas"
      ) : colum.accessor === "totalVacanciesAvailable" &&
        dataRow[colum.accessor] <= 0 ? (
        "0"
      ) : (
        "-"
      )}
    </div>
  </td>
);

          })
        : columnsMeet.map((colum: any, k) => {
            return (
              <td key={k}>
                <div>{renderAccessor(colum.accessor, dataRow)}</div>
              </td>
            );
          });

    return _row;
  };

  const [sortType, setSortType] = useState("");
  const modal = useModal();
  NiceModal.register("ModalLoadingInfo", ModalLoadingInfo);
  const modalLoading = useModal("ModalLoadingInfo");
  const [loadingTeams, setLoadingTeams] = useState(!fetchData.current);
  const [teamsError, setTeamsError] = useState(false);

  const onClickOriginPin = async (nodeCode: string, evt) => {
    evt.stopPropagation();

    if (!nodeCode) return;

    setOriginModalOpen(true);
    setOriginModalLoading(true);
    setOriginModalError(false);
    setOriginModalPath([]);

    try {
      const response = await getNodeBreadcrumb(nodeCode);
      const breadcrumbNode = response.data;
      const parentNodes = Array.isArray(breadcrumbNode?.parentNodes)
        ? breadcrumbNode.parentNodes
        : [];

      const breadcrumbPath = [...parentNodes, breadcrumbNode].filter(Boolean);
      const uniqueBreadcrumbPath = breadcrumbPath.filter(
        (item, index, path) => path.findIndex((pathItem) => pathItem.nodeCode === item.nodeCode) === index
      );

      setOriginModalPath(uniqueBreadcrumbPath);
      setOriginExpandedNodes(uniqueBreadcrumbPath.map((item) => item.nodeCode));
    } catch (error) {
      console.log(error);
      setOriginModalError(true);
    } finally {
      setOriginModalLoading(false);
    }
  };

  useEffect(() => {
    let isMounted = true;

    const loadTeams = async () => {
      if (fetchData.current) {
        setLoadingTeams(false);
        return;
      }

      try {
        let teams: any[] = [];

        if (enrollmentTargets.length > 0) {
          const targetTeams = await Promise.all(
            enrollmentTargets.map(async (target) => {
              const groupTitle = target.parentTitle || target.title;
              const groupNodeCode = target.nodeCode;

              if (Boolean(target.hasTeamAvailable)) {
                
                const response = await getTeamsRegistration({
                    limit: 30,
                    nodeCode: target.nodeCode,
                    onlyAvailable: true,
                });

                return [
                  { isGroupHeader: true, groupTitle, groupNodeCode },
                  ...response.data.result.map((team) => ({ ...team, groupTitle, groupNodeCode })),
                ];
              }

              if (Boolean(target.selfEnrollment)) {
                return [
                  { isGroupHeader: true, groupTitle, groupNodeCode },
                  {
                    isAutoEnrollment: true,
                    nodeCode: target.nodeCode,
                    name: "Auto matrícula",
                    description: target.title,
                    groupTitle,
                    groupNodeCode,
                    meetings: [],
                  },
                ];
              }

              return [];
            })
          );

          teams = targetTeams.flat();
        } else {
          
          const response = await getTeamsRegistration({
              limit: 30,
              nodeCode: idSearch,
              onlyAvailable: true,
          });
          teams = response.data.result;
        }

        if (isMounted) {
          fetchData.current = teams;
          setLoadingTeams(false);
        }
      } catch (error) {
        if (isMounted) {
          setTeamsError(true);
          setLoadingTeams(false);
        }
      }
    };

    loadTeams();

    return () => {
      isMounted = false;
    };
  }, []);

  if (teamsError) return <p>There is an error.</p>;
  if (loadingTeams || !fetchData.current) return <Preloader />;

  let currentData: any = fetchData.current;
  const currentGroups = currentData.reduce((groups, item) => {
    if (item.isGroupHeader) {
      groups.push({ title: item.groupTitle, nodeCode: item.groupNodeCode, items: [] });
      return groups;
    }

    if (groups.length === 0) {
      groups.push({ title: null, items: [] });
    }

    groups[groups.length - 1].items.push(item);
    return groups;
  }, []);
  const originModalTree = buildOriginTree(originModalPath);

  const toggleOriginNode = (nodeCode: string) => {
    setOriginExpandedNodes((current) =>
      current.includes(nodeCode) ? current.filter((id) => id !== nodeCode) : [...current, nodeCode]
    );
  };

  const renderOriginTreeNodes = (nodes) =>
    nodes.map((node) => {
      const hasChildren = node.children.length > 0;
      const isOpen = originExpandedNodes.includes(node.nodeCode);
      const level = node.nodeCode?.split(".").length || 1;
      const indent = (level - 1) * 18;
      const rowClassName = level % 2 === 1 ? "originTreeRowOdd" : "originTreeRowEven";

      return (
        <TreeItem
          key={node.nodeCode}
          nodeId={node.nodeCode}
          label={
            <div className={`instructors_treeTeam row ${rowClassName}`} style={{ paddingLeft: indent }}>
              {level !== 1 && node.label && <Label text={node.label} className="originTreeLabel" />}
              <span>{node.title}</span>

              {hasChildren && (
                <span className="instructors_treeTeam toggle">
                  {isOpen ? (
                    <KeyboardArrowUpIcon fontSize="small" />
                  ) : (
                    <KeyboardArrowDownIcon fontSize="small" />
                  )}
                </span>
              )}
            </div>
          }
          onLabelClick={(evt) => {
            evt.preventDefault();
            evt.stopPropagation();
            if (hasChildren) toggleOriginNode(node.nodeCode);
          }}
        >
          {hasChildren && renderOriginTreeNodes(node.children)}
        </TreeItem>
      );
    });

  const hasMeetings = () => {
    for (var i = 0; i < currentData.length; i++) {
      if (currentData[i].isGroupHeader || currentData[i].isAutoEnrollment) {
        continue;
      }

      if (currentData[i].hasOwnProperty("meetings")) {
        if (currentData[i].meetings.length > 0) {
          return true;
        }
      }
    }
  };

  const updateEnrollmentRequest = () => {
    updateHasEnrollmentCampaign({
      hasEnrollmentRequests: false
    })
  }

  const onClickErrolmentRequest = (item, evt) =>  {
   
    const params: any = {
      idTeam: item.idTeam,
      // nodeCode: item.nodeCode,
      // idUser: getProfileInfo().idUser,
    };

    //SOLICITANDO MATRÍCULA
    modalLoading.show({
      obj: {
        message:
          "Aguarde, realizando <span class='primaryColor'>solicitação de matrícula.</span>.",
        closeBtn: false,
        loadding: true,
      },
    });

    userEnrollmentRequest(params)
      .then((response) => {
        updateHasEnrollmentCampaign({ hasEnrollmentRequests: true})
        setTimeout(() => {
          modalLoading.remove();
          currentAwaitingApprovalTitle.current =
            item.name;
          setShowConfirmAwaitingApproval(true);
         
        }, 1000);
      })
      .catch((error) => {
        console.log(error);
      });

    evt.stopPropagation();
  }

  const classNotStartedYet = () => {
    const teamRows = currentData.filter((item) => !item.isGroupHeader && !item.isAutoEnrollment);

    if(!teamRows.length || teamRows.length > 1){
      return false
    }
    const initialDate = new Date(teamRows[0].initialDate).getTime();
    const currentDate = new Date().getTime();
    return initialDate ? initialDate > currentDate : false;
  }

  const onClickAutoEnroll = (item, evt) => {
    modalLoading.show({
      obj: {
        message:
          "Aguarde, realizando <span class='primaryColor'>a sua matrícula</span>.",
        closeBtn: false,
        loadding: true,
      },
    });

    userEnrollments({
      nodeCode: item.nodeCode,
      idUser: getProfileInfo().idUser,
    })
      .then((response) => {
        setTimeout(() => {
          history.push(`/level/${response.data.idEnrollment}`);
          modalLoading.remove();
          modal.remove();
        }, 1000);
      })
      .catch((error) => {
        console.log(error);
      });

    evt.stopPropagation();
  }

  const onClickEnroll = (item, evt) => {
    const params: any = {
      idTeam: item.idTeam,
      nodeCode: item.nodeCode,
      idUser: getProfileInfo().idUser,
    };

    modalLoading.show({
      obj: {
        message:
          "Aguarde, realizando <span class='primaryColor'>a sua matrícula</span>.",
        closeBtn: false,
        loadding: true,
      },
    });
    userEnrollments(params)
      .then((response) => {
        setTimeout(() => {
          if(classNotStartedYet()){
              window.location.reload()
              return;
          }
          history.push(
            collection.hasOwnProperty(
              "collectionToGo"
            )
              ? `/level/${response.data.idEnrollment}/${collection.collectionToGo.data.nodeCode}`
              : `/level/${response.data.idEnrollment}`
          );
          modalLoading.remove();
          modal.remove();
        }, 1000);
      })
      .catch((error) => {
        console.log(error);
      });

    evt.stopPropagation();
  }

  const meetingsInfo = () => {
    let meetingsInfoObj: any = {
      meetType: null,
      meets: null,
      adress: null,
    };

    let meetType: Array<any> = [];
    let meets: Array<any> = [];
    let adress: Array<any> = [];

    for (var i = 0; i < currentData.length; i++) {
      if (currentData[i].isGroupHeader || currentData[i].isAutoEnrollment) {
        continue;
      }

      if (currentData[i].hasOwnProperty("meetings")) {
        currentData[i].meetings.map((meet: any, i) => {
          meetType.push(
            React.createElement(
              "div",
              { className: "meetItem" },
              meet.meetingType.toUpperCase().charAt(0) +
                meet.meetingType.slice(1).toLowerCase()
            )
          );
          meetingsInfoObj.meetType = React.createElement(
            "div",
            { className: "meetRow meetType" },
            meetType
          );
          meets.push(
            React.createElement(
              "div",
              { className: "meetItem" },

              <Popup
                trigger={(open) => (
                  <div>
                    {sanitizeText(
                      convertToBrDateWithHourStartAndHourFinish(
                        meet.startDate,
                        meet.finishDate
                      ),
                      8
                    )}
                  </div>
                )}
                position="top center"
                on={["hover", "focus"]}
                arrow={true}
                closeOnDocumentClick
              >
                <div className="tooltipAdressBox">
                  {/* <Text component="p" text="Hora do encontro:" className="tooltipText"/> */}
                  <Text
                    component="p"
                    text={convertToBrDateWithHourStartAndHourFinish(
                      meet.startDate,
                      meet.finishDate
                    )}
                    className="tooltipText"
                  />
                </div>
              </Popup>
            )
          );

          meetingsInfoObj.meets = React.createElement(
            "div",
            { className: "meetRow meets" },
            meets
          );

          adress.push(
            React.createElement(
              "div",
              { className: "meetItem" },
              meet.meetingType === "PRESENCIAL" ? (
                <Popup
                  trigger={(open) => (
                    // <button className="button">Trigger - {open ? 'Opened' : 'Closed'}</button>
                    <div>
                      <LuMapPin className="adressIco clickedIco" />
                      {sanitizeText(meet.address, 10)}
                    </div>
                  )}
                  position="top center"
                  on={["hover", "focus"]}
                  arrow={true}
                  closeOnDocumentClick
                >
                  <div className="tooltipAdressBox">
                    <Text
                      component="p"
                      text="Endereço:"
                      className="tooltipText"
                    />
                    <Text
                      component="p"
                      text={meet.address}
                      className="tooltipText"
                    />

                    <p
                      className="btnAdress"
                      onClick={() => {
                        copyTextToClipboard(meet.address);
                      }}
                    >
                      Copiar
                    </p>
                  </div>
                </Popup>
              ) : (
                <>
                  <HiOutlineStatusOnline className="adressIco" />{" "}
                  {"Sala virtual"}
                </>
              )
            )
          );
          meetingsInfoObj.adress = React.createElement(
            "div",
            { className: "meetRow adress" },
            adress
          );
        });
      }
    }

    return meetingsInfoObj;
  };

  if (sortType != "") {
    currentData = currentData.sort((a, b) =>
      a[sortType] > b[sortType] ? 1 : -1
    );
  }

  return (
    <div className="modalRegistration">
      <ModalDialog
        className="darkDilog"
        btn1Info={{
          event: () => {
            setShowConfirmAwaitingApproval(false);
            modal.remove();
          },
          text: "Ok, entendi",
        }}
        htmlBody={
          <>
            <p>Obrigado por solicitar a matrícula do treinamento,</p>
            <h3>{`${collection.title}`}</h3>
            <p>Agora é só aguardar a aprovação da matrícula!</p>
            <p>
              Para acompanhar o status da solicitação acesse a área{" "}
              <a
                onClick={() => {
                  history.push("/myjourney/requestEnrollmentStatus");
                  modal.remove();
                }}
              >
                Minha Jornada
              </a>
            </p>
          </>
        }
        show={showConfirmAwaitingApproval}
      />

      <div className="modal-body-pct">
        {collectionToGo && (
          <>
            <Text
              component="p"
              text="Para acessar este treinamento:"
              className="title"
            />
            <div className="info bottonLine">
              <div className="left">
                {collectionToGo.label && (
                  <Label text={collectionToGo.label} className="label" />
                )}
                {collectionToGo.title && (
                  <Text
                    component="p"
                    text={collectionToGo.title}
                    className="title"
                  />
                )}
              </div>
              {/* <div className="right">
                {collectionToGo.description && <Text component="small" text={collectionToGo.description} />}
              </div> */}
            </div>
            <Text
              component="p"
              text="É necessário realizar matrícula em:"
              className="title"
            />
          </>
        )}

        {!collectionToGo && (
          <>
            <Text
              component="p"
              text="Para acessar este treinamento é necessário realizar a sua matrícula em uma das turmas disponíveis:"
              className="title"
            />
          </>
        )}

        <div className="info currentEnrollment">
          <div className="left currentEnrollment">
            <div className="pageTitleRow">
              {collection.label && (
                <Label text={collection.label} className="label" />
              )}
              {collection.title && (
                <Text component="p" text={collection.title} className="title" />
              )}
            </div>
            {collection.description && (
              <Text
                component="p"
                text={collection.description}
                className="pageDescription"
              />
            )}

            <div className="leftinfo">
              {collection.workload && (
                <Duration
                  text={collection.workload}
                  className="RightInfo"
                  timeFormat={"seconds"}
                />
              )}
            </div>
          </div>
          {collection.syllabus &&
            removeTagsHtml(collection.syllabus).length > 0 &&
            collection.nodeType === "LEARNING" && (
              <div className={"syllabusInfo"}>
                <button
                  onClick={(e) => setSyllabusStatus(!syllabusStatus)}
                  className={`syllabusBtn ${
                    syllabusStatus ? "syllabusBtnActive" : "syllabusBtnInactive"
                  }`}
                >
                  <span>Ver ementa</span>
                  {syllabusStatus ? <FaArrowDownLong /> : <FaArrowRightLong />}
                </button>

                <div
                  className={`syllabusContainer ${
                    syllabusStatus
                      ? "syllabusContainerOpen"
                      : "syllabusContainerClosed"
                  }`}
                >
                  {parse(`${collection.syllabus}`)}
                </div>
                {/* {syllabusStatus ? (
               
              ) : (
                <></>
              )} */}
              </div>

              // <div className="left currentEnrollment">

              //   {parse(collection.syllabus)}
              // </div>
            )}
        </div>

        {currentData.length > 0 && (
          <Text
            component="p"
            text="Este treinamento também está disponível em:"
            className="availableTrainingLabel"
          />
        )}

        <>
          <div className="deskTable">
            {currentData.length == 0 && (
              <Text component="p" text="Sem turma disponível." />
            )}

            {currentGroups.map((group, groupIndex) => (
              <div className="teamGroup" key={groupIndex}>
                {group.title && (
                  <div className="teamGroupTitle">
                    <button
                      type="button"
                      className="teamGroupPinButton"
                      onClick={(evt) => onClickOriginPin(group.nodeCode, evt)}
                    >
                      <RiMapPin2Fill className="teamGroupPinIcon" />
                    </button>
                    <span>{group.title}</span>
                  </div>
                )}

                <table>
                  <thead>
                    <tr>
                      {(!hasMeetings() ? columns : columnsMeet).map(
                        (colum: any, i) => {
                          let { header, accessor } = colum;

                          return (
                            <th key={i}>
                              <button
                                type="button"
                                onClick={() => {
                                  setSortType(accessor);
                                }}
                              >
                                <p>{header}</p> <MdUnfoldMore />
                              </button>
                            </th>
                          );
                        }
                      )}

                      <th>
                        <p>Matrícula</p>
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {group.items.map((item, j) => {
                      if (item.isAutoEnrollment) {
                        return (
                          <tr key={j}>
                            <td colSpan={(!hasMeetings() ? columns : columnsMeet).length}>
                              <div>{item.name}</div>
                            </td>
                            <td>
                              <button
                                type="button"
                                onClick={(evt) => onClickAutoEnroll(item, evt)}
                              >
                                <Label text="Matricular-se" />
                              </button>
                            </td>
                          </tr>
                        );
                      }

                      const opened = isInstructorsOpen(item.idTeam) && hasInstructors(item);
                      return (
                        <React.Fragment key={j}>
                        <tr>
                          {renderRows(item, j)}
                          <td>
                            {item.needApproval === 0 && (
                              <button
                                type="button"
                                onClick={(evt) => {onClickEnroll(item, evt)}}
                              >
                                <Label text="Matricular-se" />
                              </button>
                            )}

                            {item.needApproval === 1 &&
                              item.awaitingApproval === false && (
                                <button
                                  type="button"
                                  onClick={(evt) => onClickErrolmentRequest(item, evt)}

                                >
                                  <Label text="Solicitar matrícula" />
                                </button>
                              )}

                            {item.awaitingApproval === true && (
                              <Label
                                className="small"
                                text="Aguardando aprovação da matrícula."
                              />
                            )}
                          </td>
                        </tr>
                        {opened && (
                          <tr className="instructorsAccordionRow">
                            <td colSpan={(!hasMeetings() ? columns : columnsMeet).length + 1}>
                              <div className="instructorsAccordion">
                                <div className="instructorsAccordionTitle">Instrutores da turma:</div>

                                <div className="instructorsAccordionBox">
                                  {item.instructors.map((ins: any) => (
                                    <div key={ins.idUser} className="instructorsAccordionItem">
                                      {ins.instructorName}
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </td>
                          </tr>
                        )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ))}
          </div>

          <div className="mobTable">
            {currentData.length == 0 && (
              <Text component="p" text="Sem turma disponível." />
            )}

            {currentData.map((item, j) => {
              if (item.isGroupHeader) {
                return (
                  <div className="teamGroupTitle" key={j}>
                    <button
                      type="button"
                      className="teamGroupPinButton"
                      onClick={(evt) => onClickOriginPin(item.groupNodeCode, evt)}
                    >
                      <RiMapPin2Fill className="teamGroupPinIcon" />
                    </button>
                    <span>{item.groupTitle}</span>
                  </div>
                );
              }

              if (item.isAutoEnrollment) {
                return (
                  <table key={j}>
                    <thead>
                      <tr>
                        <th>
                          <p>{item.name} - {item.description}</p>
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td>
                          <div>
                            <strong className="valuesTitle">Matrícula: </strong>
                          </div>
                          <div className="actions">
                            <button
                              type="button"
                              onClick={(evt) => onClickAutoEnroll(item, evt)}
                            >
                              <Label text="Matricular-se" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                );
              }

              return !hasMeetings() ? (
                  <table key={j}>
                      <thead>
                          <tr>
                              <th>
                                  <p>
                                      {item.name} - {item.description}
                                  </p>
                              </th>
                          </tr>
                      </thead>

                      <tbody>
                          <tr>
                              <td>
                                  <div>
                                      <strong className="valuesTitle">Período para realização:</strong>
                                      {item.duration} dias
                                  </div>
                              </td>
                          </tr>

                          {/* <tr>
                      <td>
                        <div>
                          <strong className="valuesTitle">Capacidade: </strong>
                          {item.capacity ? item.capacity : "-"}
                        </div>
                      </td>
                    </tr> */}

                          <tr>
                              <td>
                                  <div>
                                      <strong className="valuesTitle">Data de início:</strong>
                                      {item.initialDate ? convertToBrDate(item.initialDate) : '-'}
                                  </div>
                              </td>
                          </tr>

                          <tr>
                              <td>
                                  <div>
                                      <strong className="valuesTitle">Data de término:</strong>
                                      {item.finalDate ? convertToBrDate(item.finalDate) : '-'}
                                  </div>
                              </td>
                          </tr>

                          <tr>
                              <td>
                                  <div>
                                      <strong className="valuesTitle">Vagas (Disponíveis/Total):</strong>

                                      {renderAccessor('totalVacanciesAvailable', item) === null ? (
                                          <Text text={'ilimitadas'} />
                                      ) : (
                                          <Text
                                              text={`${
                                                  renderAccessor('totalVacanciesAvailable', item) > 0
                                                      ? renderAccessor('totalVacanciesAvailable', item)
                                                      : '0'
                                              } / ${
                                                  renderAccessor('capacity', item) > 0
                                                      ? renderAccessor('capacity', item)
                                                      : '0'
                                              }`}
                                          />
                                      )}
                                  </div>
                              </td>
                          </tr>
                          <tr>
                              <td className="instructorsMobileRow">
                                  <strong className="valuesTitle">Instrutores:</strong>

                                  {hasInstructors(item) ? (
                                      <button
                                          type="button"
                                          className="instructorsToggleMobile"
                                          onClick={(e) => {
                                              e.stopPropagation();
                                              toggleInstructors(item.idTeam);
                                          }}
                                      >
                                          <span className="instructorsToggleText">
                                              {item.totalInstructors ?? item.instructors.length} visualizar
                                          </span>
                                      </button>
                                  ) : (
                                      <span>-</span>
                                  )}
                              </td>
                          </tr>

                          {hasInstructors(item) && isInstructorsOpen(item.idTeam) && (
                              <tr>
                                  <td className="instructorsMobileAccordionCell">
                                      <div className="instructorsMobileAccordion">
                                          {item.instructors.map((ins: any) => (
                                              <div key={ins.idUser} className="instructorsMobileAccordionItem">
                                                  {ins.instructorName}
                                              </div>
                                          ))}
                                      </div>
                                  </td>
                              </tr>
                          )}

                          <tr>
                              <td>
                                  <div>
                                      <strong className="valuesTitle">Matrícula: </strong>
                                  </div>
                                  <div className="actions">
                                      {item.needApproval === 0 && (
                                          <button
                                              type="button"
                                              onClick={(evt) => {
                                                  onClickEnroll(item, evt);
                                              }}
                                          >
                                              <Label text="Matricular-se" />
                                          </button>
                                      )}

                                      {item.needApproval === 1 && item.awaitingApproval === false && (
                                          <button type="button" onClick={(evt) => onClickErrolmentRequest(item, evt)}>
                                              <Label text="Solicitar matrícula" />
                                          </button>
                                      )}

                                      {item.awaitingApproval === true && (
                                          <Label className="small" text="Aguardando aprovação da matrícula." />
                                      )}
                                  </div>
                              </td>
                          </tr>
                      </tbody>
                  </table>
              ) : (
                  <table key={j}>
                      <thead>
                          <tr>
                              <th>
                                  <p>
                                      {item.name} - {item.description}
                                  </p>
                              </th>
                          </tr>
                      </thead>

                      <tbody>
                          <tr>
                              <td>
                                  <div>
                                      <strong className="valuesTitle">Período para realização:</strong>
                                      {renderAccessor('period', item)}
                                  </div>
                              </td>
                          </tr>

                          <tr>
                              <td>
                                  <div>
                                      <strong className="valuesTitle">Encontros:</strong>

                                      <table>
                                          <tr className="meetsMob">
                                              <td>
                                                  <div>{renderAccessor('meetType', item)}</div>
                                              </td>
                                              <td>
                                                  <div>{renderAccessor('meets', item)}</div>
                                              </td>
                                              <td>
                                                  <div>{renderAccessor('adress', item)}</div>
                                              </td>
                                          </tr>
                                      </table>
                                  </div>
                              </td>
                          </tr>

                          <tr>
                              <td>
                                  <div>
                                      <strong className="valuesTitle">Vagas (Disponíveis/Total):</strong>
                                      <Text
                                          text={`${
                                              renderAccessor('totalVacanciesAvailable', item) !== null
                                                  ? renderAccessor('totalVacanciesAvailable', item)
                                                  : '-'
                                          } / ${
                                              renderAccessor('capacity', item) !== null
                                                  ? renderAccessor('capacity', item)
                                                  : '-'
                                          }`}
                                      />
                                  </div>
                              </td>
                          </tr>

                          <tr>
                              <td>
                                  <div>
                                      <strong className="valuesTitle">Matrícula: </strong>
                                  </div>
                                  <div className="actions">
                                      {item.needApproval === 0 && (
                                          <button
                                              type="button"
                                              onClick={(evt) => {
                                                  onClickEnroll(item, evt);
                                              }}
                                          >
                                              <Label text="Matricular-se" />
                                          </button>
                                      )}

                                      {item.needApproval === 1 && item.awaitingApproval === false && (
                                          <button type="button" onClick={(evt) => onClickErrolmentRequest(item, evt)}>
                                              <Label text="Solicitar matrícula" />
                                          </button>
                                      )}

                                      {item.awaitingApproval === 1 && (
                                          <Label className="small" text="Aguardando aprovação da matrícula." />
                                      )}
                                  </div>
                              </td>
                          </tr>
                      </tbody>
                  </table>
              );
            })}
          </div>
        </>

        <button className="closeBtn" onClick={() => modal.remove()}>
          <IoMdClose />
        </button>

        {originModalOpen && (
          <div className="originTrainingModalOverlay" onClick={() => setOriginModalOpen(false)}>
            <div className="originTrainingModalDialog" onClick={(evt) => evt.stopPropagation()}>
              <div className="modal-support-blur modal-support-blur-warning" style={{ borderRadius: 10 }} />

              <div className="modal-principal-warning originTrainingModalContent">
                <div className="originTrainingModalHeader" id="origin-training-modal-title">
                  <span className="instructors_treeTeam title">Origem do treinamento</span>
                  <button
                    type="button"
                    onClick={() => setOriginModalOpen(false)}
                    className="modal-warning-close-container originTrainingModalClose"
                  >
                    <CloseIcon style={{ color: "#4A4A4A" }} className="modal-warning-close" />
                  </button>
                </div>

                <div className="modal-body-warning originTrainingModalBody">
                  {originModalLoading && <Preloader />}

                  {!originModalLoading && originModalError && (
                    <Text component="p" text="Não foi possível carregar a origem do treinamento." />
                  )}

                  {!originModalLoading && !originModalError && (
                    <div className="originTrainingModalTreeWrapper">
                      <TreeView className="instructors_treeTeam root" expanded={originExpandedNodes}>
                        {renderOriginTreeNodes(originModalTree)}
                      </TreeView>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
});
const mapDispatchToProps = (dispatch) => ({
  updateHasEnrollmentCampaign: (item) =>
    dispatch(updateHasEnrollmentCampaign(item)),
});

export default connect(null, mapDispatchToProps)(ModalRegistration);
